module.exports = __webpack_public_path__ + "static/media/zm.53783063.svg";